export const shippingKeys = {
  all: ["shipping"] as const,
  lists: () => [...shippingKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) => [...shippingKeys.lists(), filters] as const,
  totals: (filters: Record<string, unknown>) => [...shippingKeys.all, "totals", filters] as const,
  details: () => [...shippingKeys.all, "detail"] as const,
  detail: (id: string) => [...shippingKeys.details(), id] as const,
};
